// ID部分可传配置对象

/**
 * 给context的default value，实际上是无效数据。初始化组件时就应该被外部真是值所覆盖
 */
export var translator = {
  $st: function $st(id, values) {
    return "TODO $st";
  },
  $stn: function $stn(value, precision) {
    return "TODO $stn";
  }
};

/**
 * 给context的default value，实际上是无效数据。初始化组件时就应该被外部真是值所覆盖
 */
export var $st = function $st(id, values) {
  return translator.$st(id, values);
};
export var $stn = function $stn(value, precision) {
  return translator.$stn(value, precision);
};